// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch_switch__nE6i_","slider":"switch_slider__RFe7M","left_side":"switch_left_side__EJqFC","right_side":"switch_right_side__TEb4g"};